// src/utils/encryption.js
import CryptoJS from "crypto-js";

const SECRET_KEY =
  process.env.REACT_APP_SECRET_KEY || "your_secret_key_32chars";

export const encryptPassword = (password) => {
  return CryptoJS.AES.encrypt(password, SECRET_KEY).toString();
};
